module.exports = __webpack_public_path__ + "img/book-chl.6cddea9f.svg";